import React from "react";
import { Progress } from "antd";

const LocationProcess = ({ single, style, AI }) => {
	const height_style = style;

	return (
		<div
			className="custom_scroll pl-15 pr-15"
			style={{ height: height_style, width: "100%", overflow: "auto" }}
		>
			{single[0]?.x?.map((item, i) => {
				return (
					<div className="row mb-15">
						<div className="col-4 text_regular">
							{AI ? (
								<a
									href={single[0].links[i]}
									target="_blank"
									style={{
										textDecoration: "underline",
										textDecorationColor: "#185EDF",
									}}
									rel="noreferrer"
								>
									{item}
								</a>
							) : (
								<div>{item}</div>
							)}
						</div>
						<div className="col-8">
							<Progress
								className="text_regular"
								percent={single[0]?.percent[i]}
								status="active"
							/>
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default LocationProcess;
